import Repository from '../axios'

const  resource = "/admin/permissions";
export default {
  get() {
    return Repository.get(`${resource}`)
  },
};
